module.exports = __webpack_public_path__ + "static/intro-right-flower-b04ff458685e3d1bdaccaf6f4f9751cf.png";